module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "ch3"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("THREE")]), _c('br'), _vm._v("Tel-Aviv’s Foundation Myth: A Constructive Perspective")]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('em', [_vm._v("Hizky Shoham")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Foundation Myths")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many historical cities have invented their “sense of place” through myths of origin, which mark symbolic borders between chaos and cosmos, or nature and culture."), _c('a', {
    attrs: {
      "id": "rch3en1"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en1"
    }
  }, [_vm._v("1")])]), _vm._v(" In modern cities with rapidly changing physical cityscapes, myths are used to create a sense of continuity in the form of local traditional practices, local sites of memory, shared beliefs about the city’s unique “climate” (intellectual Boston, romantic Venice, effervescent Tel-Aviv, etc.), and foundation myths."), _c('a', {
    attrs: {
      "id": "rch3en2"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en2"
    }
  }, [_vm._v("2")])]), _vm._v(" As in every other “mnemonic society,” newcomers and the next generation are socialized into the city’s collective memory by “libraries, bibliographies, folk legends, photo albums, and television archives . . . history textbooks, calendars, eulogies, guest books, tombstones, war memorials . . . pageants, commemorative parades, anniversaries, and various public exhibits of archaeological and other historical objects.”"), _c('a', {
    attrs: {
      "id": "rch3en3"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this context, my concern is the construction of the urban anniversary and its own kind of identity construction through retrospective myths of origins. Commemorating a specific moment of creation, the anniversary signifies the border between chaos and cosmos not only in time, but also in space. It symbolically differentiates the city from the chaos that preceded the city’s existence and the chaos that still surrounds it. Occurring on the same calendar date, it makes a clear connection between the past moment of a city’s creation and its ongoing creation in the present. On the other hand, it also demonstrates a linear narrative "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("of continuous development from the modest beginning in the past to the massive present, emphasizing the rapid changes in urban landscape, thus evoking nostalgia. The existence of a city’s active and functioning foundation myth can thus indicate the existence of a sense of place, that is, its functioning as a social site of identity construction through “mnemonic socialization” or “mnemonic tradition[s].”"), _c('a', {
    attrs: {
      "id": "rch3en4"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The various myths of Tel-Aviv are the focus of many diverse recent studies."), _c('a', {
    attrs: {
      "id": "rch3en5"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en5"
    }
  }, [_vm._v("5")])]), _vm._v(" This essay deals with the gradual appearance of Tel-Aviv’s foundation myth in the public sphere during the interwar years, its formative period, with 1929 and 1934 as datum-points of its twentieth and twenty-fifth anniversaries. The development of Tel-Aviv’s foundation myth both reflected and created Tel-Aviv’s becoming a distinct “place” with its own collective memory—which did not exist before World War I. The foundation myth, which was already crystallized in the 1930s, and has become common knowledge, includes the following basic themes:")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumbert"
  }, [_vm._v("1. There was a founding ceremony linked to the land lottery held on 11 April 1909, during the Passover holiday, which was meticulously planned by entrepreneur Akiva Arye Weiss, the first chairman of Ahuzat Bayit.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_vm._v("2. The founders dared to envision a huge Hebrew (another version, Jewish) city on the desolate desert sand. The urbanized entity whose growth began in the 1920s is an institutional, political, socio-economical, and cultural continuation of the suburb, or the Jewish neighborhood(s), of the late Ottoman Era. World War I was but a temporary break in this linear process.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_vm._v("3. The suburb was built by “Hebrew labor,” by Jewish workers.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_vm._v("4. A somewhat surprising theme: There were many disputes and personal conflicts among the first founders, especially between Weiss and Dizengoff.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_vm._v("5. The myth, especially as reflected in Soskin’s famous photograph, symbolizes the creation "), _c('em', [_vm._v("ex nihilo")]), _vm._v(" of the city “from the sands,” and the self-perception of the Zionist project as a universal civilizing project of colonizing the wilderness. Implicitly, the emphasis on the sands motif constructed and fortified the sense of separation and independence of Tel-Aviv from its rival national-urban space, Jaffa."), _c('a', {
    attrs: {
      "id": "rch3en6"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("This foundation myth reflected the highly urbanized Tel-Aviv during the Mandate. However, in 1909, this myth was generally unknown or at least did not yet function as a myth. The formation of the components of this myth, their inclusion in its history, and their projection back to "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("their alleged origins, provide a clear case study for a micro-historical examination of the invention of tradition."), _c('a', {
    attrs: {
      "id": "rch3en7"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en7"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although it is broadly agreed that the foundation myth was invented retroactively, its diachronic development has remained unstudied, except for some comments by Feirberg."), _c('a', {
    attrs: {
      "id": "rch3en8"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en8"
    }
  }, [_vm._v("8")])]), _vm._v(" I rely on his important deconstructive study of the “land lottery” photograph, but adopt a chronological-philological method. I carefully follow the gradual construction of a new collective memory from micro-details, which were joined together to form a complete story. The narrative was gradually created through public images and accounts from the genesis period with some contributions by memory agents, who relied on more or less reliable sources, from oral stories and memories to diaries and historical documents. However, the chronological-philological study of the myth focuses not only on historical “discoveries,” but also on common knowledge implicitly accepted as true. This development reveals a consistent process of growth of the myth and enrichment of details that were assumed about the city’s foundation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The myth was not invented out of the blue by talented authors with powerful imaginations, or by politicians with personal and group interests, nor was its author the protagonist, the city itself."), _c('a', {
    attrs: {
      "id": "rch3en9"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en9"
    }
  }, [_vm._v("9")])]), _vm._v(" It was a story that was told, written, photographed, retold, rewritten, and reinterpreted in the city’s homes, streets, newspapers, pamphlets, public events, and cafés. This essay examines mainly the written versions, or the written traces of oral versions of this story. The unexplained gaps between these sources reveal the common assumptions about the origins of Tel-Aviv, which, in the typical dynamics of folktales, differ from each other only in minor details."), _c('a', {
    attrs: {
      "id": "rch3en10"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en10"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The focus on these common beliefs about the origin of the city engendered a methodological focus on public discourse, while the institutionalization of the anniversaries will be discussed here in passing. This essay concentrates on the retroactive determination of the city’s exact genesis point in the calendar, while the other components of the myth are studied only secondarily. The study begins with the late Ottoman Era and examines the reaction to the founding of Ahuzat Bayit as a place separate from Jaffa. Then it traces the first appearances of the idea of a genesis point during the 1920s, and its chronological development into a whole foundation myth during the British era, and the myth as it is well known today.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('strong', [_vm._v("Was Ahuzat Bayit Ever Founded?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The history of Ahuzat Bayit may be told or written in alternative ways. The most commonly recalled version in Tel-Aviv’s collective memory, and mostly employed by institutional historians, considers the neighborhood to be totally different from its predecessors, such as Neve Tzedek, Neve Shalom, and Mahane Israel."), _c('a', {
    attrs: {
      "id": "rch3en11"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en11"
    }
  }, [_vm._v("11")])]), _vm._v(" Unlike these previous neighborhoods, Ahuzat Bayit necessitated preconstruction general planning; it behaved like a semi-political association that collected taxes and enforced by-laws, and was an eminently bourgeois settlement project whose establishment immediately influenced Jaffa’s leisure-culture."), _c('a', {
    attrs: {
      "id": "rch3en12"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en12"
    }
  }, [_vm._v("12")])]), _vm._v(" Some scholars also point to the existence of the city “as a dream” much before its actual establishment, and see its urban development as a realization of a pre-existing idea."), _c('a', {
    attrs: {
      "id": "rch3en13"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en13"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nevertheless, other historians prefer to write the history of Tel-Aviv only after World War I. They point to the rapid urban development of the British era, which was totally different from the rural development of the Jewish neighborhoods of Ottoman Jaffa. These authors, whose orientation is more toward the social sciences, tend to allude to “Mandate Tel-Aviv” in their publication titles."), _c('a', {
    attrs: {
      "id": "rch3en14"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en14"
    }
  }, [_vm._v("14")])]), _vm._v(" Others, who wrote the history of Jaffa or Ottoman Palestine, see Ahuzat Bayit as an integral part of it, and tend to conclude its story during World War I or a little later."), _c('a', {
    attrs: {
      "id": "rch3en15"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en15"
    }
  }, [_vm._v("15")])]), _vm._v(" Hanna Ram criticizes the dominant narrative, pointing to its anachronistic dimension. Ahuzat Bayit was but another failed attempt to deal with the limited accommodations in Jaffa, as were Jaffa’s other novel neighborhoods."), _c('a', {
    attrs: {
      "id": "rch3en16"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The truth lies somewhere in between, and depends on methodology and ideology. In terms of narrative, however, the dominant narrative marks, in time and space, a new beginning of the “new” city of Tel-Aviv as differentiated from the “old” Jaffa, whereas the second narrative speaks about a much more gradual process without a single point of departure (but with 1921 as a datum-point). How, then, did Ahuzat Bayit itself symbolically mark the new beginning? To what extent was the new neighborhood referred to as a different place, and since when?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If one traces the development of Ahuzat Bayit through contemporaneous sources alone, there is no doubt that there was no founding ceremony. No contemporaneous source mentioned the land lottery of 20 Nisan (11 April 1909) as a festive event. Those who did mention the "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("lottery described it as a merely technical task. Even Weiss’s retrospective memoirs, written in 1934 when the myth had already permeated the public sphere, did not describe a ceremony, symbolical act, or even festive feelings linked to the event."), _c('a', {
    attrs: {
      "id": "rch3en17"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en17"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was no such foundation ceremony during any other phase of the colonization process conducted “for the first time,” such as the approval of the loan to Ahuzat Bayit members by JNF in October 1908, or announcement of the completion of the land transaction on 9 November. The first land lottery was not even commemorated. According to Druyanov, that event took place during the Jewish holiday of Sukkot in 5669 (1908) when forty-one lots were distributed. In fact, there were at least two lotteries."), _c('a', {
    attrs: {
      "id": "rch3en18"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en18"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It seems that there was no commemoration of the foundation of the society on the eve of 28 Av (18 August 1906)—perhaps because the society existed before under other names."), _c('a', {
    attrs: {
      "id": "rch3en19"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en19"
    }
  }, [_vm._v("19")])]), _vm._v(" Nor did anyone commemorate the beginning of the construction of the first house of Ahuzat Bayit, by Reuven and Rivka Segal, in June 1909. According to Weiss’s memory, this event is described as festive—but apparently not enough to remember and commemorate the specific date."), _c('a', {
    attrs: {
      "id": "rch3en20"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en20"
    }
  }, [_vm._v("20")])]), _vm._v(" Segal himself was described (in typical bourgeois rhetoric, as though he were there alone, without his wife) as a modern embodiment of the biblical Nachshon in his daring to begin construction in the desert without a guaranteed water supply. However, the real reason for the delays in the construction work was the endless debates about Hebrew labor. The Segal family was the first to begin construction because they “compromised” by using Arab labor—as most of the founding families eventually did."), _c('a', {
    attrs: {
      "id": "rch3en21"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en21"
    }
  }, [_vm._v("21")])]), _vm._v(" The “pioneering” act of the Segals was thus highly controversial and far from festive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only known public ceremony that took place during the first stage of Ahuzat Bayit was the laying of the cornerstone of the Herzliya Gymnasia, 28 July 1909. Many years later David Smilansky recalled this historical moment as an elaborate ceremony, but at that time he defined the ceremony as “modest,” and promised: “The main celebration will take place upon the completion of the construction.”"), _c('a', {
    attrs: {
      "id": "rch3en22"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en22"
    }
  }, [_vm._v("22")])]), _vm._v(" It was never thought of as the foundation event of Tel-Aviv.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was no public ceremony held upon the completion of the first houses in October 1909, nor the habitation of the last houses of the first group, in February 1910. One exception was a Tu Bishvat planting "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("ceremony by Ahuzat Bayit’s school children, one day before the association’s first assemblage in the built neighborhood."), _c('a', {
    attrs: {
      "id": "rch3en23"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en23"
    }
  }, [_vm._v("23")])]), _vm._v(" However, no one commemorated this day as the founding date of Tel-Aviv. In retrospect, it might have been ironic if the most agricultural Zionist festival would have marked Tel-Aviv’s anniversary, which represented Urban Zionism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lack of an established foundation date was made evident by David Smilansky, who, in January 1912, reported that, “This neighborhood was built during the last 2–3 years.”"), _c('a', {
    attrs: {
      "id": "rch3en24"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en24"
    }
  }, [_vm._v("24")])]), _vm._v(" The obvious lack of a public foundation ceremony for the neighborhood does not necessarily indicate the absence of a mythical discourse linked to the new suburb. Yosef Klausner, who visited Tel-Aviv in April 1912, not only ceaselessly celebrated the Hebrew and European character of the suburb, but also related to it as a place separate from Jaffa even in casual speech, and celebrated its administrative independence, or as he saw it, its “self-leadership.” Tel-Aviv was a Jaffa neighborhood—but novel and quite different from Neve Tzedek and Neve Shalom in its European cleanliness, independent political organization, and its formal adoption of the Hebrew language. Klausner noted that, “Only three years ago this sand covered also the location on which this lovely neighborhood is now standing.”"), _c('a', {
    attrs: {
      "id": "rch3en25"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en25"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Klausner, whose impressions were published in "), _c('em', [_vm._v("Hashiloach")]), _vm._v(" in 1912–14, may be regarded as the first mythologist of Tel-Aviv. His articles were the first known texts that made an explicit connection between Zionist ideologies (the political Zionism of the civilizing process of the Jews through Zionist colonization and the cultural Zionism of the revival of Hebrew language) and Tel-Aviv as the specific place of their supposed embodiment. This was the first text that mentioned the sands as the greater opponent of the civilizing project.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, even for Klausner, Tel-Aviv was not an urban locale and did not have urban aspirations. There is no evidence that anyone thought about Tel-Aviv as a separate urban space, not even in the story “The Land’s Puzzle” by Kabak (1912–14), the only literary text that mentioned Tel-Aviv before World War I. He described it as a peaceful bourgeois suburb blended into the pastoral sands. The one passage often quoted by literary critics and scholars as a prediction of Tel-Aviv’s urban future is, in fact, part of a utopian discourse which, according to the narrative, still held no sway in the Yishuv, especially not for Tel-Aviv’s bourgeois residents."), _c('a', {
    attrs: {
      "id": "rch3en26"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en26"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("It is not impossible that some of the founders of the suburb dared to dream about a mass-city that would be “Palestinian New York,” as Weiss described his vision in retrospect. In his 1934 memoirs, Weiss quoted the first Ahuzat Bayit brochure, which was the most important documentary evidence of the existence of the urban vision for Tel-Aviv before World War I. However, as Ram notes, the brochure was reconstructed from Weiss’s memory. Moreover, even according to his version, no more than five copies of the brochure were printed, for the members of the association’s first executive committee."), _c('a', {
    attrs: {
      "id": "rch3en27"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en27"
    }
  }, [_vm._v("27")])]), _vm._v(" There is the (unlikely) possibility that Weiss indeed envisioned an urban entity, “a Hebrew city,” but if he did, this thought had no significant public manifestation. Many of the association’s actions actually contradicted the urban vision, such as the initial prohibition of commercial activity, the closing of Herzl Street on the Sabbath, and especially the notorious location of the Herzliya Gymnasia."), _c('a', {
    attrs: {
      "id": "rch3en28"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en28"
    }
  }, [_vm._v("28")])]), _vm._v(" The lack of a symbolical foundation act lends further testimony to the idea that Tel-Aviv was not initially conceived as a mass-city.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The absence of a foundation ceremony could have been the outcome of prosaic causes, such as concerns regarding Ottoman authorities or limited financial means. Historians cannot responsibly conclude anything from something that did not happen. We know for certain that there was no one single moment of symbolical foundation. This moment could have only been invented retrospectively.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The texts of Klausner, Kabak, and a few others are the exceptions. Even to the extent that Tel-Aviv was considered a unique nationalist project by its entrepreneurs or residents, others at that time who drew a picture of the Zionist project in Ottoman Palestine did not view the neighborhood as worth mentioning. That was the case not only for labor-movement-oriented writers."), _c('a', {
    attrs: {
      "id": "rch3en29"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en29"
    }
  }, [_vm._v("29")])]), _vm._v(" Ya’ary-Poleskin did not write a single word on the founders of Tel-Aviv or its construction process (in describing Ruppin’s deeds, for example) in his 1922 anthology "), _c('em', [_vm._v("Dreamers and Warriors")]), _vm._v(". In 1926, he became Dizengoff’s biographer and glorified the first Hebrew city, but in his 1922 anthology he referred to Tel-Aviv as a residential quarter of Jaffa, or as a small town, although he worked there himself and clearly recognized its nationalist character."), _c('a', {
    attrs: {
      "id": "rch3en30"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en30"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tel-Aviv was founded as a Jaffa neighborhood, an important and unique one, but as part of Jaffa’s urban space. In terms of the construction of local Jewish identity, Jaffa was mainly contrasted with Jerusalem, "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("as the center of “the new Yishuv.” Tel-Aviv made its contributions to this image of Jaffa, but it was not more important than Neve Tzedek, for example, the Jewish intellectual center in Jaffa, or other “self-governing” colonies and urban suburbs in “the new Yishuv.”"), _c('a', {
    attrs: {
      "id": "rch3en31"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en31"
    }
  }, [_vm._v("31")])]), _vm._v(" Whatever the limited extent of Tel-Aviv’s distinctiveness with regard to Jaffa, it had not yet become a mnemonic society, a separate place of identity construction. This happened only during the Mandate.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("The Early 1920s: The First Steps")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("British rule in Palestine stimulated rapid development for Tel-Aviv, which lost its suburban character in favor of a typical industrial urbanizing space. Tel-Aviv gradually became recognized and experienced as an urban space different from Jaffa. This development was preceded by intense negotiation between the Tel-Aviv committee and the Mandate authorities concerning the measure of Tel-Aviv’s municipal autonomy. In his first request to high commissioner Herbert Samuel, Dizengoff emphasized, “Our most urgent aspiration is to reach a [status of a] small township, like an English ‘borough’.”"), _c('a', {
    attrs: {
      "id": "rch3en32"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en32"
    }
  }, [_vm._v("32")])]), _vm._v(" A few months later, on 11 May 1921, Tel-Aviv obtained the status of “township” that implied a partial autonomy from Jaffa. Instead of the former Tel-Aviv committee, whose “sovereignty” was legitimized on a voluntary basis, Tel-Aviv was now a formal political body with some administrative autonomy and juridical authorities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although absolute autonomy was obtained only in 1927, when Tel-Aviv and Jaffa were declared two separate municipal authorities, talk about the first Hebrew city circulated in 1921. There were two sorts of mythical urban Zionist discourse: the political-institutional and the urban-civilizing. The former relates to the formal and informal administrative independence of Tel-Aviv municipality, which was considered not only a political achievement in itself, but also a sort of political experiment of Jews in self-government for “the first time in modern era.” The latter relates to the civilizing urban project of ruling nature and creating a new society "), _c('em', [_vm._v("ex nihilo")]), _vm._v(", employing the desolate sands as its ultimate symbol. During the 1920s, these two discourses were the source of two different narratives about Tel-Aviv’s beginnings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In March 1921, shortly before the declaration of Tel-Aviv as a township, the Tel-Aviv committee published the first issue of "), _c('em', [_vm._v("Yedi’ot")]), _vm._v(" ’"), _c('em', [_vm._v("Iriyat "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("Tel-Aviv")]), _vm._v(" (municipal bulletin). Among ongoing technical and administrative issues, the residents were also notified that")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The committee prepares and is about to publish a memorial book of the neighborhood Tel-Aviv. This book should have been printed a year ago, when the first Hebrew town on our land reached ten years, but it was delayed, not in our fault, and will now be fulfilled when the small neighborhood is going to become a large and autonomic town."), _c('a', {
    attrs: {
      "id": "rch3en33"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en33"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Quite typically, the first talk about the need to write Tel-Aviv’s history appears with a sense of dramatic change in the town’s legal status and self-perception."), _c('a', {
    attrs: {
      "id": "rch3en34"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en34"
    }
  }, [_vm._v("34")])]), _vm._v(" This text assumed political-institutional continuity between the predicted urban entity of Tel-Aviv and the past neighborhood, and implied that the new township of Tel-Aviv should continue using the old committee. It is not surprising that the beginning of Tel-Aviv was dated back to 1910 (according to the text, Tel-Aviv reached its first decade a year before 1921), when the Tel-Aviv committee was established and the Ahuzat Bayit association was disassembled."), _c('a', {
    attrs: {
      "id": "rch3en35"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en35"
    }
  }, [_vm._v("35")])]), _vm._v(" The defining moment was the decision to establish a new self-governing committee for the neighborhood. The same narrative appeared in 1922, in an article by Dizengoff in "), _c('em', [_vm._v("Ha’aretz")]), _vm._v(", which dealt with political-institutional issues, and mentioned “12 years of Tel-Aviv’s existence,” referring to its administrative dimension."), _c('a', {
    attrs: {
      "id": "rch3en36"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en36"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A different narrative appeared in the next issue of "), _c('em', [_vm._v("Yedi’ot")]), _vm._v(" ’"), _c('em', [_vm._v("Iriyat Tel-Aviv")]), _vm._v(" after the formal recognition of Tel-Aviv as a township. According to that issue,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The dream that was dreamed by those who left Jaffa 12 years ago and went to set up homes in the desolated sands of Ahuzat Bayit, was ceaselessly formed during these years, until it now received the real and whole form of recognizing Tel-Aviv as a primal city in Israel. At the first time in Jewish history . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("The text elaborated upon the basic component of the Tel-Aviv myth so far—the city as an independent semi-political entity—and then described how the new status of the city offered expanded opportunities, and concluded, “Tel-Aviv will rise and flourish, and will be the main Hebrew city in all Palestine and one of the most important cultural and industrial centers all over the East.”"), _c('a', {
    attrs: {
      "id": "rch3en37"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en37"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("This chronology better fits the civilizing narrative, which emphasizes the creation of a new European civilization in Asia. The defining moment was not the decision to establish a new semi-political body, but the heroic creation of a new civilization in the desert (here in this text, the desert is also a metonym for the entire East, to be civilized by Zionist Palestine). This new narrative looked back not to 1910, the institutional origin of Tel-Aviv, but rather to 1909 (twelve years before), the pioneering beginning of the construction in the middle of the sand dunes, or the creation "), _c('em', [_vm._v("ex nihilo")]), _vm._v(" of a new civilization in the wilderness. No single act of foundation was mentioned, but the story of “leaving Jaffa” for the “desolate sands” to construct new homes there in the “new” place, allegedly outside Jaffa, served the purpose of symbolically separating Tel-Aviv from Jaffa, as cosmos is divided from chaos.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tel-Aviv at this stage was perceived, at least by its leaders, as the prospect of urban Zionism, despite the fact that in the summer of 1921 Tel-Aviv was but a small town with a few thousand residents at most."), _c('a', {
    attrs: {
      "id": "rch3en38"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en38"
    }
  }, [_vm._v("38")])]), _vm._v(" Urban Zionism, so far a mere utopian vision, now had Tel-Aviv as its distinct and defined space-time site. Urban Zionism began its transformation from utopia to ideology."), _c('a', {
    attrs: {
      "id": "rch3en39"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en39"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nevertheless, at this stage, these narratives remained underdeveloped and their reverberation in public discourse was limited. The memorial book was not published, and for several reasons there was no public celebration to commemorate the new township status."), _c('a', {
    attrs: {
      "id": "rch3en40"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en40"
    }
  }, [_vm._v("40")])]), _vm._v(" However, the town developed rapidly, and people told the story of the first families and their conquest of the desolated dunes. One such narrator was Ludwig Lewisohn, a Jewish-American reporter who visited Tel-Aviv in 1925. He told the story of sixty families that gathered on the sand dunes, but thought it happened only in 1919. The inaccuracy may be partly explained by the fact that the existence of the town as a town, both as an independent municipal entity (at least partially) and as an urban-Zionist project, began only after World War I."), _c('a', {
    attrs: {
      "id": "rch3en41"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en41"
    }
  }, [_vm._v("41")])]), _vm._v(" This is the first written record that references the mythical number of sixty families. If there was any commemoration of the city’s foundation in 1924, its fifteenth anniversary, Lewisohn could not have made such a mistake, yet no such public commemoration was held."), _c('a', {
    attrs: {
      "id": "rch3en42"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en42"
    }
  }, [_vm._v("42")])]), _vm._v(" It seems that there was no consensus about 1909 as the foundation year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("This lack of a specific foundation date was also evident in two historical articles that were published by Alter Druyanov in "), _c('em', [_vm._v("Yedi’ot")]), _vm._v(" ’"), _c('em', [_vm._v("Iriyat Tel-Aviv")]), _vm._v(" in September 1925, only a few months after Lewisohn’s article. In prosaic language, and relying on both primary sources and memories, he told the story of Ahuzat Bayit from the initiative taken in the summer of 1906 until the decision of the association’s general assemblage to choose the name Tel-Aviv for the new neighborhood, on the eve of 13 Iyar (21 May 1910). The decision was presented as the climactic, most festive moment in the process. The two articles published in 1925, unlike Druyanov’s 1936 narrative, recalled no other foundation occasion."), _c('a', {
    attrs: {
      "id": "rch3en43"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en43"
    }
  }, [_vm._v("43")])]), _vm._v(" In 1936 he adopted the civilizing narrative, while here he followed the institutional one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The foundation myth, between 1920 and 1926, points to a lack of consensus regarding public recognition of Tel-Aviv as a separate urban space with its own uniquely constructed identity. Following the 1921 recognition of Tel-Aviv’s “township,” the committee’s officials immediately began referring to their community using the Hebrew word "), _c('em', [_vm._v("ir")]), _vm._v(", which denotes both a large city and an average-sized town. Yet, in the 1920s, many of Tel-Aviv’s residents still referred to Jaffa when speaking about “the city.”"), _c('a', {
    attrs: {
      "id": "rch3en44"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en44"
    }
  }, [_vm._v("44")])]), _vm._v(" In a novel published in 1923, historical Tel-Aviv during World War I was referred to as a small town."), _c('a', {
    attrs: {
      "id": "rch3en45"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en45"
    }
  }, [_vm._v("45")])]), _vm._v(" In the local news section in newspapers, reports about Tel-Aviv in 1920–1921 still referred to “Jaffa.” Over the decade, these sections gradually referred to “Jaffa and Tel-Aviv” or vice versa, and only toward 1928–1929 were Tel-Aviv and Jaffa referred to separately."), _c('a', {
    attrs: {
      "id": "rch3en46"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en46"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the lack of a clear foundation moment, people in Tel-Aviv told stories about its founding, and the mythical number of sixty families was already spoken of (although only fifty-five houses were in fact built in the first stage of Ahuzat Bayit)."), _c('a', {
    attrs: {
      "id": "rch3en47"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en47"
    }
  }, [_vm._v("47")])]), _vm._v(" Memory agents like Druyanov became more active, and the interest in the beginnings of Tel-Aviv gradually penetrated public consciousness. The existence of Tel-Aviv as a mnemonic society was in the process of being created, but the issue of the exact foundation date did not seem to provoke any public interest.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("1926–1929: The Genesis Emerges")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The dramatic change occurred not through a text or a narrative, but by a visual image. In 1926, Abraham Soskin, a photographer who lived in "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("Tel-Aviv, published a small book titled "), _c('em', [_vm._v("Tel-Aviv")]), _vm._v(". According to the brief introduction, Tel-Aviv was “first founded in 1909” by those “who settled on the desert sand dunes.” One photo in the album displayed a group of people on a sand dune, with the caption: “The meeting founding Tel-Aviv 1908.”"), _c('a', {
    attrs: {
      "id": "rch3en48"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en48"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to Feirberg, this was the first appearance of evidence of a founding event for Ahuzat Bayit, though the nature of the photographed event was unclear."), _c('a', {
    attrs: {
      "id": "rch3en49"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en49"
    }
  }, [_vm._v("49")])]), _vm._v(" The photo was also included in a biography of Dizengoff, published in the same year by Ya’ary-Poleskin, with the caption “Laying the cornerstone to the neighborhood Tel-Aviv,” but without mentioning any date."), _c('a', {
    attrs: {
      "id": "rch3en50"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en50"
    }
  }, [_vm._v("50")])]), _vm._v(" Soskin interpreted it in retrospect as the first assemblage, but not as a ceremony, and hence dated it 1908, before the actual beginning of the project, and probably even before the completion of land purchase. Unlike Soskin, Ya’ary-Poleskin further interpreted the occasion depicted in the photo as a symbolical foundation event, and was the first to imbue it with the festive aura of a genesis moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For several years, the photo was quickly disseminated and republished, sometimes with one of two interpretations: it was thought to record either the first meeting of the association in 1908, presenting the institutional narrative; or the laying of Tel-Aviv’s cornerstone in 1909, presenting the civilizing one."), _c('a', {
    attrs: {
      "id": "rch3en51"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en51"
    }
  }, [_vm._v("51")])]), _vm._v(" Meanwhile, the option of 1910 was implicitly abandoned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1929, it was already clear that the city was founded in 1909 and, for the first time, Tel-Aviv celebrated its twentieth anniversary. Many commented that a literal anniversary (i.e., the Hebrew term "), _c('em', [_vm._v("yovel")]), _vm._v(") should be celebrated only in the twenty-fifth or fiftieth year, and suspected that the occasion was an aspect of the notorious Tel-Aviv “enthusiasm for celebrations.”"), _c('a', {
    attrs: {
      "id": "rch3en52"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en52"
    }
  }, [_vm._v("52")])]), _vm._v(" However, the city took the opportunity to celebrate itself and to articulate the urban-Zionist ideology. A large ceremony was held, the first founders were honored, and their group photo was taken for history’s sake (though they could trace the representatives of only thirty-four families, much fewer than the mythical sixty)."), _c('a', {
    attrs: {
      "id": "rch3en53"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en53"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A festive anthology was published, collecting excerpts from almost all the known texts that mentioned Tel-Aviv, from Kabak and Klausner of the Ottoman era, to contemporary authors who praised Tel-Aviv especially for the occasion. Even the writer Y. H. Brenner, who deeply disliked bourgeois Tel-Aviv, was recruited. Soskin’s photo was chosen "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("to open the anthology, with the caption: “Laying the cornerstone of the neighborhood of Tel-Aviv,” without the date."), _c('a', {
    attrs: {
      "id": "rch3en54"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en54"
    }
  }, [_vm._v("54")])]), _vm._v(" The whole anthology was already marked by the mythical tone of the civilizing narrative, which now began to take over. Consider these memories by Shalom Ash:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("When I was in Palestine in 1908, I saw a pole stuck in the sands nearby Jaffa, into which a placard was stapled: Tel-Aviv. One Jew was going around the town, holding a map with the structure of a city with its streets, boulevards and gardens, and offered pieces for sale. I was offered to purchase the whole coast for no money. I said to myself: there you have Jews’ businesses! Do they presume building a city on the sand?! Today there is a large city, populated with 20,000 people."), _c('a', {
    attrs: {
      "id": "rch3en55"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en55"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("In 1908, no placard or a map of a “city with its streets, boulevards and gardens” existed. However, the fictive dimension of Ash’s “memory” is well integrated into the utopian characterization of the city, which allegedly informed the actual creation of the city on the sands. The repeating motif of the sands illustrated the “illogical” idea of building a city in the middle of nowhere. In his speech, Dizengoff emphasized that")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Sixty people, equipped with no money or previous experience, but with a will alone, stood up and built a small campus, and developed it into a large city despite the “lack of reason” in it—to build houses on the wandering sand and to establish a city without a previous “hinterland.”"), _c('a', {
    attrs: {
      "id": "rch3en56"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en56"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("The power of the human will was the utopian motive that Herzl weaved into urban Zionism, glorifying technology and human engineering. To prove the connection between utopian thought and Tel-Aviv, Dizengoff reversed the chronology of the city’s geographical development from a “hinterland,” a rural area, to an urban space. In his inverted narrative, the pioneers already knew that they had established a city, and the hinterland came only later. Urban Zionism continued to develop from mere utopian thought into a specific ideology connected to a specific place. Tel-Aviv, on the other hand, embraced the utopian idea as part of its self-image, as a place “where dreams come true.” The civilizing narrative was taken a step further, and the foundation myth was charged with the utopian power of the will."), _c('a', {
    attrs: {
      "id": "rch3en57"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en57"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet the foundation myth was missing a key component: an exact anniversary date of the founding of Tel-Aviv. In 1929, this question remained unanswered. In a special column to the press, Dizengoff admitted that")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("None of us can ascertain in what day of 1909 Tel-Aviv was born. Whether on the day of the signing on the contract between the 60 founders and the APK [Anglo-Palestine company bank], or on the day of the purchase of the first lot, or maybe on the day of the laying of the cornerstone to the first house—since the idea to establish a Hebrew city was not born in one day. Nevertheless, we determined the day of 22 Nisan, "), _c('em', [_vm._v("isru-hag")]), _vm._v(" of Passover, to be our city’s birthday. Every year from now on, we will think about our deeds related to our city on this day, and outline the path to go in the following years."), _c('a', {
    attrs: {
      "id": "rch3en58"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en58"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("The absence of a fixed foundation date thus sharpened the awareness of the social functions of the myth. The date 22 Nisan was supposed to be institutionalized as “Tel-Aviv Day,” although Dizengoff declared that “we will always remember 11 May 1921, on which Tel-Aviv was granted its first constitution—the Scroll of Independence from Jaffa’s custody, our charter of autonomy.”"), _c('a', {
    attrs: {
      "id": "rch3en59"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en59"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why, then, was 22 Nisan, or 2 May, chosen for the anniversary date and not 11 May, for instance? The last day of the “Levant Exhibition and Fair” was 2 May 1929."), _c('a', {
    attrs: {
      "id": "rch3en60"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en60"
    }
  }, [_vm._v("60")])]), _vm._v(" The Tel-Aviv municipality wrapped together a few tourist events—Purim carnival, the Levant Fair, and the “Macabiah” (“the Jewish Olympic games”) into “the spring events,” in a successful attempt to create a tourist season for Tel-Aviv."), _c('a', {
    attrs: {
      "id": "rch3en61"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en61"
    }
  }, [_vm._v("61")])]), _vm._v(" As Dizengoff himself declared in his opening speech at the exhibition, “The spring season—the tourism season, was chosen this year to coincide with Tel-Aviv’s anniversary.”"), _c('a', {
    attrs: {
      "id": "rch3en62"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en62"
    }
  }, [_vm._v("62")])]), _vm._v(" On the day after the anniversary "), _c('em', [_vm._v("Ha’aretz")]), _vm._v(" commented, “Our tourism season is over,” and reported on the development of tourism in Tel-Aviv."), _c('a', {
    attrs: {
      "id": "rch3en63"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en63"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Establishing the city’s celebration at a time when many tourists were already visiting both enhanced tourism in general and added to the city’s symbolic capital. Aside from their economic success, the “spring events” celebrated the ideology of urban Zionism and its contributions to the Zionist project, with Tel-Aviv at its center."), _c('a', {
    attrs: {
      "id": "rch3en64"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en64"
    }
  }, [_vm._v("64")])]), _vm._v(" “Tel-Aviv Day” on 22 Nisan was thus an attempt to create a new date on the Zionist calendar, in which urban Zionism would celebrate its own festival and its own ideology, without necessarily commemorating a specific historic birthday.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The anniversary generated a great deal of discourse (in newspapers and journals) in favor of Tel-Aviv and its prospects, and urban Zionism in general. Even the labor-movement newspaper "), _c('em', [_vm._v("Davar")]), _vm._v(" quoted Dizen"), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("goff on the futility of the class category in nation-building, and offered its own interpretation of the merits of the first Hebrew city, employing the myth of the Hebrew labor."), _c('a', {
    attrs: {
      "id": "rch3en65"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en65"
    }
  }, [_vm._v("65")])]), _vm._v(" The pro-urban "), _c('em', [_vm._v("Doar Hayom")]), _vm._v(" published a few festive columns: Jabotinsky inaugurated Tel-Aviv as no less than “our capital city,” without irony. Itamar Ben-Avi, a veteran supporter of urban colonization, added that “2 May (or its Hebrew alternative!) will remain a great date in the history of Palestine from now on—the day of Hebrew independence.”"), _c('a', {
    attrs: {
      "id": "rch3en66"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en66"
    }
  }, [_vm._v("66")])]), _vm._v(" From that date forward, urban Zionism would always be commemorated in the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The twentieth anniversary also saw the first appearance of the land lottery in the foundation myth in some of the histories, legends, and glorifications of Tel-Aviv. David Izmujik, one of the founders, wrote:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("On the way to Nablus after the German colony, in front of Sheikh Ali’s grove, there is a valley, and behind it there are sand dunes. The wind reshapes them every year. Here and there dry grape vines are thrown aside like corpses, and the dominance in the environment are lonely, distant sycamores.—This is Tel-Aviv twenty years ago, the land of Ahuzat Bayit in those days. The sixty families, the members of Ahuzat Bayit, were ingathering in small groups after the lottery was executed, each family celebrating its sandy dust that fell to be its estate, measuring and setting borders, some on the hills, some in the plain, all are happy with their share . . ."), _c('a', {
    attrs: {
      "id": "rch3en67"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en67"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("The text continues with a sentimentalized glorification of the founders who dared to build their homes in the middle of the desert. The function of the lottery in this narrative is double: (1) to emphasize the peaceful and natural cooperation between the founders, who were happy with what they had despite the unequal way the shares were divided; and (2) to signify the first moment when the desolate desert was marked by civilization. Combining these two functions, the lottery powerfully signified the idea of colonization by private capital: everyone had private property, but the national goal united them in the manner of a commune and prevented jealousies."), _c('a', {
    attrs: {
      "id": "rch3en68"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en68"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although they knew that Tel-Aviv was not founded on a specific date, the search for a genesis moment was enhanced from that time onward. Yosef Eliyahu Chelouche also mentioned the lottery, as a consequence of a conflict between Weiss and Sapir, the representative of APK. According to Chelouche, the members could not wait to begin the "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v("construction, and hence, “in [Hebrew] 5669 (1909) the lottery was done in a festive manner.”"), _c('a', {
    attrs: {
      "id": "rch3en69"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en69"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chelouche adds nothing to the word “festive,” not even the exact date or the exact manner of the lottery, let alone a bit of atmosphere. However, this festive theme conflicts with the one described by Izmujik, who tells of the alleged personal conflicts among the founders, which supposedly had no ideological or socio-political basis. The conflicts about “Hebrew labor” were absent from his story, although he personally played a major role in them as the contractor of many homes, the gymnasia, and some public works. He also recycled the myth of the city’s premature urbanity and omitted the initial debates about shops."), _c('a', {
    attrs: {
      "id": "rch3en70"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en70"
    }
  }, [_vm._v("70")])]), _vm._v(" Ironically, this emphasis on the personal conflicts among the founders preserves the two unified myths of Hebrew-ness and urbanity by concealing the ideological dimension of the disagreements which hindered construction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The twentieth anniversary was also celebrated by gatherings of the founders who told stories from the early period. We have evidence of one event that was held in the Casino Café, a party in which the founders made a kind of oral "), _c('em', [_vm._v("haggada")]), _vm._v(", telling of a new exodus, not from Egypt but from Jaffan-Christian Ajami, the “Germans neighborhood,” and the rest of Jaffa’s streets and passageways."), _c('a', {
    attrs: {
      "id": "rch3en71"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en71"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The writer reported an undocumented story about “the first Shabbat” after the completion of the land purchase, with other stories and memories from the genesis period. Stories such as these were probably told often, and contributed details to the larger narrative of the city’s beginnings. However, since the founders were alive, and some were important public figures, their versions were thought to be more reliable. Though details were added to the myth of origins, they did not cohere into a fixed narrative until the mid-1930s.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("1934–1936: Fixation")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nothing seemed more natural than to celebrate Tel-Aviv’s twenty-fifth anniversary in 1934. On 12 January Tel-Aviv was formally accorded city status, its importance to the Zionist project was acknowledged, and the year 1909 was already fixed in collective memory as the year of the city’s founding. The Levant Fair attracted international attention, and now included a “jubilee pavilion” that described the twenty-five-year history "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _vm._v("of the city and another pavilion that displayed paintings of the cityscape. The fair was conducted from 26 April to 2 May; the main anniversary celebration was held on its final day and a few days after. Unlike the twentieth anniversary that was held in a closed space, the main event of the twenty-fifth anniversary was held in the new stadium with an audience of 10,000 and was broadcast on the radio. All the newspapers in Palestine published special supplements for the occasion, and many congratulatory telegrams ware received from all over the world. It was an impressive demonstration of the power of urban Zionism."), _c('a', {
    attrs: {
      "id": "rch3en72"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en72"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many narratives about the history of Tel-Aviv appeared around 1934, including different periodizations, stories about the beginning of the city, and even a nostalgic comic play, which was performed during the celebrations, on the naiveté of the founders who did not predict Tel-Aviv’s urbanization. Dr. Matmon-Cohen of the Herzliya Gymnasia, for example, tried to convince the public that its foundation ceremony in July 1909 was in fact the foundation ceremony of the neighborhood, and did not hide his interest in integrating the school’s story with that of the city’s."), _c('a', {
    attrs: {
      "id": "rch3en73"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en73"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One powerful myth that acquired more public prominence was the image of Dizengoff, “the city’s father,” who had led Tel-Aviv since 1910. This personal cult included the naming of a central plaza for his wife as part of the celebrations."), _c('a', {
    attrs: {
      "id": "rch3en74"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en74"
    }
  }, [_vm._v("74")])]), _vm._v(" It may seem as though this particular myth would have included the institutional narrative that dated the beginning of the city to 1910, when Dizengoff took over the Tel-Aviv committee; however, even the cult of Dizengoff was absorbed into the civilizing narrative tied to the 1909 date.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The film "), _c('em', [_vm._v("This is the Land")]), _vm._v(" (produced in 1934 by Baruch Agadati, screened in 1935) greatly contributed to the civilizing narrative. The film integrated both staged and documentary scenes in a “docu-drama” fashion, describing the Zionist project as a universal drama of the struggle of civilization and wilderness. The civilizing story of Tel-Aviv was well assimilated into this narrative: One scene reconstructs Soskin’s photo, but adds a speech by Dizengoff (who played himself, wearing a mustache), in which he declares that this is a cornerstone for a small neighborhood but that he envisions a large city. Toward the film’s end, footage of the real Dizengoff in his festive speech on the twenty-fifth anniversary is shown, when he compared the daring vision with the reality that even "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("surpassed the dream. The connection between the foundation of the city and its present reality was formed not by the calendar, but by the person who was the founder (here individual, not plural), whose vision came true. The same narrative, using that photo, was repeated in Dizengoff’s 1935 election propaganda."), _c('a', {
    attrs: {
      "id": "rch3en75"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en75"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The photo was also used as part of the “then and now” motif on the cover of the festive double edition of "), _c('em', [_vm._v("Yedi’ot")]), _vm._v(" ’"), _c('em', [_vm._v("Iriyat Tel-Aviv")]), _vm._v(", where it was defined as “the first assemblage” in 1909"), _c('a', {
    attrs: {
      "id": "rch3en76"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en76"
    }
  }, [_vm._v("76")])]), _vm._v(" that penetrated deeply into the collective memory. However, since much more was now known publicly about the beginnings of Tel-Aviv, the determination of the celebration’s date required the following explanation:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Despite the fact that the cornerstone of the first house was laid on the 15 of Sivan 5669 [1909], the Tel-Aviv municipality decided, due to technical reasons, to move the celebrations forward and organize them during the days of the Levant Fair and exhibition (which will be called “the jubilee exhibition”)."), _c('a', {
    attrs: {
      "id": "rch3en77"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en77"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Implicit here was the persistence in keeping the 2 May date chosen in 1929 as “Tel-Aviv Day,” although the Hebrew date moved from 23 Nisan in 1929 to 17 Iyar in 1934. The justification for this calendar choice was “technical reasons”: the Zionist civil religion generally preferred the Hebrew calendar, while the Gregorian was used for everyday needs. Chronicles and memoirs of Tel-Aviv’s foundation usually mentioned only Hebrew dates. The anniversary should have symbolically repeated the moment of creation, and its inability to do so required justification. The writer A. Z. Ben-Yishai assumed that the beginning of the construction should be used as the point of origin, in the best of civilizing tradition, and signified the laying of the cornerstone of the Segals’ house on 15 Sivan as this genesis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In contrast to Dizengoff’s 1929 narrative, it was now clear that the foundation event would be on a spring date. Before the celebrations, Dizengoff wrote that the twenty-fifth anniversary “will be celebrated in the spring of [Hebrew] 5694. Only 25 years passed since the cornerstone to this city was laid in a desolate desert north of Jaffa.”"), _c('a', {
    attrs: {
      "id": "rch3en78"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en78"
    }
  }, [_vm._v("78")])]), _vm._v(" Dizengoff did not exactly say that there was a cornerstone-laying ceremony, and his use of this expression could be a metaphor that reflected the absorption of the institutional narrative into the civilizing one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("Several publications about Tel-Aviv from 1934 to 1936 mentioned that Tel-Aviv was, in principle, founded in the spring of 1909. A 1936 pamphlet by Ben-Yishai stated, “The corner-stone of the first house in the suburb was laid in the spring of 1909.”"), _c('a', {
    attrs: {
      "id": "rch3en79"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en79"
    }
  }, [_vm._v("79")])]), _vm._v(" The creation of Tel-Aviv in the spring season was common knowledge, inferred retrospectively from the traditional celebration on 2 May as part of the spring events.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, the anniversary was not yet connected to the lottery. Weiss, who began publishing his memoirs in 1934, did not mention one single moment of creation, but rather many, in his narrative; every “first event” was festive and caused spontaneous (but not organized) celebration. Weiss was probably unhappy with his marginalization by the celebration organizers, who defined him as only “one of the founders,” minimizing his historical contributions. Nevertheless, he did not portray his lottery as the moment of genesis, simply because it never occurred to him."), _c('a', {
    attrs: {
      "id": "rch3en80"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en80"
    }
  }, [_vm._v("80")])]), _vm._v(" Other witnesses also recalled the event as an illustration of Weiss’s resourcefulness and vigor, and added a few colorful details, but did not see it as a genesis."), _c('a', {
    attrs: {
      "id": "rch3en81"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en81"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These new facts about the city’s founding, combined with the assumption that there was indeed a founding moment, can explain Druyanov’s interpretation of the famous photo of the lottery that first gave Tel-Aviv its date of birth. As Feirberg comments, the historical sources of this identification are unclear. However, it is possible that Druyanov was pushed into this interpretation by three commonly known assumptions about the beginning: that (1) there was a moment of genesis, which (2) was commemorated in the photo, and (3) occurred in the spring of 1909. However, the photo did not appear to capture a cornerstone ceremony, since no building activity is seen in it. Druyanov had enough sources to find another event that may not have been described as festive, but luckily, “the camera left us this moment as an eternal memory.” Although he added some atmosphere to the description of the event, he explicitly mentioned that, “they did not know that they were the first to build the first Hebrew city,” depicting this event as only a retroactive foundation."), _c('a', {
    attrs: {
      "id": "rch3en82"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en82"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is not impossible that Druyanov’s personal bias in favor of Dizengoff made him feel uncomfortable linking the founding event to his bitter old rival Weiss. This bias may have contributed to the invention of the story about the location of the lottery on Dizengoff’s private estate. "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _vm._v("The later declaration of Israel’s independence in this exact location was but another historical and mythical irony.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This version was not immediately and fully accepted as the authorized (hi)story of the foundation of the city. In 1941, Ze’ev Vilnai thought that the lottery took place during Sukkot of 5669 [October 1908], and not in Passover 1909, but he also captioned the photo “Laying the foundation stone to the neighborhood—Tel-Aviv,” while in the chronological list in the same publication he wrote that this was also the day of the lottery. This was based on Druyanov’s 1925 articles. Repeating the narrative about the wilderness that existed before the founding of Tel-Aviv, Vilnai assumed that the cornerstone ceremony and the lottery were the same event—filling another gap that Druyanov left."), _c('a', {
    attrs: {
      "id": "rch3en83"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en83"
    }
  }, [_vm._v("83")])]), _vm._v(" The commingling of the land lottery and the foundation ceremony was more or less accepted as the constitutive myth of Tel-Aviv.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For many reasons, the years from the twenty-fifth to the fiftieth anniversary were a period of relative decline in the status of Tel-Aviv as a site of national identity construction, and public interest in its myth of origins decreased accordingly. When, in the 1950s, interest was renewed, the story of the land lottery was already extant, ready for use, with the alleged backup of Druyanov’s historiographical authority."), _c('a', {
    attrs: {
      "id": "rch3en84"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en84"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The story of the myth in its formative period is a story of multiplication of details along with a unification of narrative. As long as the story was told and retold, and made use of additional sources, it presented a more coherent narrative, richer in detail. Sometimes the retelling of the story charged it with additional meanings, and sometimes previously assumed meanings created new details that filled narrative gaps. The question as to “When exactly was Tel-Aviv established?” found an authorized answer: “In the land lottery on Passover, 11 April 1909.”")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Myth and Social Necessities")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This partial reconstruction of the complicated process of the crystallization of the genesis myth of Tel-Aviv has been described from micro-details, which taken separately do not necessarily possess a distinguished symbolic quality. The creation of the specific coherent narrative of the land lottery, and the respective dating of the genesis, partly came about "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _vm._v("due to prosaic necessities, such as the decision to celebrate urban Zionism during the spring season.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This process provided a rare opportunity to employ philological tools and track the crystallization of a folktale, with its characteristic mythical modern-urban theme—the struggle of civilization and wilderness, and the power of human will. This investigation revealed that the story had no one creator or author. Druyanov’s versions, considered quite authoritative, were not of his own creation, except for the closing of a few minor gaps—just like his predecessors’ and successors’ versions. As an immigrant society, Tel-Aviv invented its own nativity by telling a story of mythical colonization. The mythical power of the story thus reveals the groundlessness of a binary opposition between nativity and colonization."), _c('a', {
    attrs: {
      "id": "rch3en85"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en85"
    }
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The evolution of Tel-Aviv into a separate urban space and a place of Zionist identity construction during the interwar years created a mnemonic society with its own myths and rituals of memory. In the case of Tel-Aviv, it was necessary to signify the border with Jaffa not only in space but also in time, by finding a symbolic point of genesis."), _c('a', {
    attrs: {
      "id": "rch3en86"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en86"
    }
  }, [_vm._v("86")])]), _vm._v(" As a cultural form, by which the society would count its years of existence and celebrate itself, the modern anniversary combines the linear and cyclical: it counts years and reflects on progress, but also returns to the same day on the calendar and reflects on the continuity of the “place.”"), _c('a', {
    attrs: {
      "id": "rch3en87"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en87"
    }
  }, [_vm._v("87")])]), _vm._v(" Thus the 1929 narrative that “Tel-Aviv was not founded on one day,” did not hold sway for long.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, one must not fall into a sociological-deterministic trap that sees the invention of tradition as a mere result of hidden social needs."), _c('a', {
    attrs: {
      "id": "rch3en88"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en88"
    }
  }, [_vm._v("88")])]), _vm._v(" It was not inevitable that this specific myth, and not another, would become the city’s primary myth. The development of the narrative as described here was extremely incidental. In addition to social needs, it was, first and foremost, the outcome of several practical decisions as well as genuine attempts of people to understand their past. It would not take much, for example, for the institutional narrative to take over, since the city’s political independence was also an important component of its image. The celebration of the city’s birthday could have been on 11 May 1921, 21 May 1910, or Tu Bishvat 1910. If one of these dates had been chosen, the constitutive myth of the city could be much (or a little) different. Current attempts to see the myth as an unequivocal "), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _vm._v("factor that predetermined the destiny of Tel-Aviv and Jaffa are retroactive wisdom, and do not reflect the flexible, fluid, and prosaic nature of history."), _c('a', {
    attrs: {
      "id": "rch3en89"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch3en89"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_vm._v("NOTES")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "ch3en1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en1"
    }
  }, [_vm._v("1")]), _vm._v(". Mircea Eliade, "), _c('em', [_vm._v("The Myth of Eternal Return, or Cosmos and History")]), _vm._v(" (Princeton, 1954), 12–21; Yi-Fu Tuan, "), _c('em', [_vm._v("Space and Place: The Perspective of Existence")]), _vm._v(" (Minneapolis, 1977); “The City: Its Distance from Nature,” "), _c('em', [_vm._v("The Geographical Review")]), _vm._v(" 68.1 (1978): 1–12.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "ch3en2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en2"
    }
  }, [_vm._v("2")]), _vm._v(". Henry Lefebvre, "), _c('em', [_vm._v("Writing on Cities")]), _vm._v(" (Cambridge, 1996), 67; Eviatar Zerubavel, "), _c('em', [_vm._v("Time Maps: Collective Memory and the Social Shape of the Past")]), _vm._v(" (Chicago, 2003), 40–43.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "ch3en3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en3"
    }
  }, [_vm._v("3")]), _vm._v(". Zerubavel, "), _c('em', [_vm._v("Time Maps")]), _vm._v(", 6.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "ch3en4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en4"
    }
  }, [_vm._v("4")]), _vm._v(". Compare Zerubavel, "), _c('em', [_vm._v("Time Maps")]), _vm._v(", 3–5; Edward Muir, "), _c('em', [_vm._v("Civic Ritual in Renaissance Venice")]), _vm._v(" (Princeton, 1981), 70–74; Mona Ozouf, "), _c('em', [_vm._v("Festivals and the French Revolution")]), _vm._v(" (Cambridge, 1988), 166–186; William M. Johnston, "), _c('em', [_vm._v("Celebrations: The Cult of Anniversaries in Europe and the United States Today")]), _vm._v(" (New Brunswick, 1991); Thomas E. Forest, “Disaster Anniversary: A Social Reconstruction of Time,” "), _c('em', [_vm._v("Sociological Inquiry")]), _vm._v(" 63.4 (1993): 444–456; Lyn Spillman, "), _c('em', [_vm._v("Nation and Commemoration: Creating National Identities in the United States and Australia")]), _vm._v(" (Cambridge, 1997); Jeffrey K. Olick, ed., "), _c('em', [_vm._v("States of Memory: Continuities, Conflicts, and Transformations in National Retrospection")]), _vm._v(" (London, 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "ch3en5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en5"
    }
  }, [_vm._v("5")]), _vm._v(". Mark LeVine, "), _c('em', [_vm._v("Overthrowing Geography: Jaffa, Tel-Aviv, and the Struggle for Palestine 1880–1948")]), _vm._v(" (Berkeley, 2005); Sharon Rotbard, "), _c('em', [_vm._v("White City, Black City: Architecture and War in Tel-Aviv and Jaffa")]), _vm._v(" (Tel-Aviv, 2005) [Hebrew]; Barbara E. Mann, "), _c('em', [_vm._v("A Place in History: Modernism, Tel-Aviv, and the Creation of Jewish Urban Space")]), _vm._v(" (Stanford, 2006); Maoz Azaryahu, "), _c('em', [_vm._v("Tel-Aviv: Mythography of a City")]), _vm._v(" (Syracuse, 2007).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "ch3en6"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en6"
    }
  }, [_vm._v("6")]), _vm._v(". For example see Nathan Dunevitz, "), _c('em', [_vm._v("Tel-Aviv: Sands that Became a City")]), _vm._v(" (Tel-Aviv, 1959), 14–15; Joseph Arikha, "), _c('em', [_vm._v("Tel-Aviv: 60 Years")]), _vm._v(" (Tel-Aviv, 1969), 12–13; Shlomo Shva, "), _c('em', [_vm._v("Ho, City, Ho, Mother")]), _vm._v(" (Tel-Aviv, 1974), 243–252. For scholarly accounts see: Mann, "), _c('em', [_vm._v("A Place in History")]), _vm._v(", 74–76; Azaryahu, "), _c('em', [_vm._v("Tel-Aviv")]), _vm._v(", 54–58; Rotbard, "), _c('em', [_vm._v("White City, Black City")]), _vm._v(", 78–88 [all in Hebrew]; LeVine, "), _c('em', [_vm._v("Overthrowing Geography")]), _vm._v(", 126–132.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "ch3en7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en7"
    }
  }, [_vm._v("7")]), _vm._v(". Eric Hobsbawm and Terence Ranger, eds., "), _c('em', [_vm._v("The Invention of Tradition")]), _vm._v(" (Cambridge, 1983), 12–14.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "ch3en8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en8"
    }
  }, [_vm._v("8")]), _vm._v(". Yaacov Shavit and Gideon Biger, "), _c('em', [_vm._v("The History of Tel-Aviv: From Neighborhoods to City (1909–1936)")]), _vm._v(" (Tel-Aviv, 2001), 69–72; Rotbard, "), _c('em', [_vm._v("White City, Black City")]), _vm._v(", 83–85. Hayim Feirberg, “The Land Lottery of Ahuzat Bayit: The Creation of Urban Mythology,” "), _c('em', [_vm._v("Israel")]), _vm._v(" 4 (2003): 87–103 [all in Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "ch3en9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en9"
    }
  }, [_vm._v("9")]), _vm._v(". Compare Shavit and Biger, "), _c('em', [_vm._v("The History of Tel-Aviv")]), _vm._v(", 9–10.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en10"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en10"
    }
  }, [_vm._v("10")]), _vm._v(". Urban written myths can be analyzed as folktales if they have different but genetically similar versions. See Alan Dundes and Carl R. Pagter, "), _c('em', [_vm._v("Urban Folklore from the Paperwork Empire")]), _vm._v(" (Austin, 1975), xix (and thanks to Amit Asis!).")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en11"
    }
  }, [_vm._v("11")]), _vm._v(". Shavit and Biger, "), _c('em', [_vm._v("The History of Tel-Aviv")]), _vm._v(", 64; see Biger, “The Expansion of Tel-Aviv’s Built Territories,” in "), _c('em', [_vm._v("Idan: The Beginnings of Tel-Aviv, 1909–1934")]), _vm._v(", ed. Mordechai Naor (Jerusalem, 1984), 47; Nurit Govrin, “Jerusalem and Tel-Aviv as Metaphors in Hebrew Literature,” "), _c('em', [_vm._v("Modern Hebrew Literature")]), _vm._v(" 2 (1989): 43–47; Moshe "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _vm._v("Zimmerman, "), _c('em', [_vm._v("Tel-Aviv was Never Small")]), _vm._v(" (Tel-Aviv, 2001), 13; Azaryahu, "), _c('em', [_vm._v("Tel-Aviv")]), _vm._v(", 33. Unsurprisingly, the first to offer this narrative was Alter Druyanov, "), _c('em', [_vm._v("Sefer Tel-Aviv")]), _vm._v(" (Tel-Aviv, 1936), 66 [all in Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en12"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en12"
    }
  }, [_vm._v("12")]), _vm._v(". Boaz Lev Tov, “ ‘Controversial Recreation’: Patterns of Leisure and Popular Culture of Jews in Palestine between 1882–1914, as Reflecting Social Transformations” (PhD diss., Tel-Aviv, 2007), 118–120 [Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en13"
    }
  }, [_vm._v("13")]), _vm._v(". Shavit, “Love and Hatred to a Non-Exist City,” "), _c('em', [_vm._v("Moznayim")]), _vm._v(" 1–2 (1984): 32 [Hebrew]. See also Joachim Schlor, "), _c('em', [_vm._v("Tel-Aviv: From a Dream to City")]), _vm._v(" (London, 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en14"
    }
  }, [_vm._v("14")]), _vm._v(". Anat Helman, "), _c('em', [_vm._v("Surrounded by Light and Sea: Everyday Life in Mandate Tel-Aviv")]), _vm._v(" (Haifa, 2008); Deborah Bernstein, "), _c('em', [_vm._v("Marginal Women: Gender and Nationalism in Mandate Tel-Aviv")]), _vm._v(" (Jerusalem, 2008); Tammy Razi, "), _c('em', [_vm._v("Forsaken Children: The Backyard of Mandate Tel-Aviv")]), _vm._v(" (Tel-Aviv, 2009) [all in Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en15"
    }
  }, [_vm._v("15")]), _vm._v(". Yossi Katz, "), _c('em', [_vm._v("Private Entrepreneurship in the Jewish Settlement of Palestine during Second Aliya")]), _vm._v(" (Ramat-Gan, 1989); Ruth Kark, "), _c('em', [_vm._v("Jaffa: A City in Evolution 1799–1917")]), _vm._v(" (Jerusalem, 1990); Ilan Shchori, "), _c('em', [_vm._v("A Dream that Became a City: Tel-Aviv, Birth and Growth—the City that Gave Birth to a State")]), _vm._v(" (Tel-Aviv, 1991), 67; Gur Alroey, "), _c('em', [_vm._v("Immigrants: Jewish Immigration to Palestine in the Early Twentieth Century")]), _vm._v(" (Jerusalem, 2004), 163 [all in Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en16"
    }
  }, [_vm._v("16")]), _vm._v(". Hana Ram, “The Genesis of Tel-Aviv: Image and Reality,” "), _c('em', [_vm._v("Moznayim")]), _vm._v(" 1–2 (1984): 70–72 [Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en17"
    }
  }, [_vm._v("17")]), _vm._v(". Akiva Arye Weiss, "), _c('em', [_vm._v("The Beginning of Tel-Aviv")]), _vm._v(" (Tel-Aviv, 1957), 123–125 [Hebrew]; Feirberg, “The Land Lottery of Ahuzat Bayit.”")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en18"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en18"
    }
  }, [_vm._v("18")]), _vm._v(". “Materials for the History of Tel-Aviv,” "), _c('em', [_vm._v("YITA")]), _vm._v(" ("), _c('em', [_vm._v("Yedi’ot")]), _vm._v(" ’"), _c('em', [_vm._v("Iriyat Tel-Aviv")]), _vm._v(") (1.9.1925) 1; 2–3 (15.9.1925) 26–27 [Hebrew]. Listed anonymously, but the author is Druyanov.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en19"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en19"
    }
  }, [_vm._v("19")]), _vm._v(". Druyanov, "), _c('em', [_vm._v("Sefer Tel-Aviv")]), _vm._v(", 64–65.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en20"
    }
  }, [_vm._v("20")]), _vm._v(". I have a few versions: 15 Sivan (below, note 57); “one of the last days of Sivan” (Weiss, "), _c('em', [_vm._v("The Beginning of Tel-Aviv")]), _vm._v(", 142); “a few days after Shavuot” (Druyanov, "), _c('em', [_vm._v("Sefer Tel-Aviv")]), _vm._v(", 110–111); or 10 Sivan (Naor, "), _c('em', [_vm._v("Idan")]), _vm._v(", 205).")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en21"
    }
  }, [_vm._v("21")]), _vm._v(". Y. Ya’ary-Poleskin, "), _c('em', [_vm._v("Dreamers and Warriors")]), _vm._v(" (Jaffa/Petah-Tikva, 1922), 93 [Hebrew]; Druyanov, “Materials for the History of Tel-Aviv,” 2–3, 26. Druyanov’s 1936 version omitted this part. See also Shchori, "), _c('em', [_vm._v("A Dream that Became a City")]), _vm._v(", 67.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en22"
    }
  }, [_vm._v("22")]), _vm._v(". David Smilansky, “The Beginning,” in "), _c('em', [_vm._v("Tel-Aviv: A Historical-Literary Reader")]), _vm._v(", ed. Yosef Aricha (Tel-Aviv, 1969?), 45–47; Yossi Katz, ed., "), _c('em', [_vm._v("A City is Born")]), _vm._v(" (Tel-Aviv, 1981), 95. See also Ya’ary-Poleskin, "), _c('em', [_vm._v("Dreamers and Warriors")]), _vm._v(", 93–94; Baruch Ben-Yehuda, ed., "), _c('em', [_vm._v("The Story of Gymnasia “Herzliya”")]), _vm._v(" (Tel-Aviv, 1970), 55 [all in Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en23"
    }
  }, [_vm._v("23")]), _vm._v(". Druyanov, "), _c('em', [_vm._v("Sefer Tel-Aviv")]), _vm._v(", 123–144.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en24"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en24"
    }
  }, [_vm._v("24")]), _vm._v(". Smilansky, "), _c('em', [_vm._v("A City is Born")]), _vm._v(", 133.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en25"
    }
  }, [_vm._v("25")]), _vm._v(". Yosef Klausner, "), _c('em', [_vm._v("A Becoming World")]), _vm._v(" (Odessa, 1915), 38–46 [Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en26"
    }
  }, [_vm._v("26")]), _vm._v(". See especially p. 19 in A. A. Kabak, “The Land’s Puzzle,” "), _c('em', [_vm._v("Hashiloah")]), _vm._v(" 31 (1914): 10–19, 124–135, 205–218 [Hebrew]; Govrin, “Jerusalem and Tel-Aviv,” 45; and Mann, "), _c('em', [_vm._v("A Place in History")]), _vm._v(", 82, n. 25.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en27"
    }
  }, [_vm._v("27")]), _vm._v(". Weiss, "), _c('em', [_vm._v("The Beginning of Tel-Aviv")]), _vm._v(", 86. The book collected different texts that were published in different forums since 1934.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en28"
    }
  }, [_vm._v("28")]), _vm._v(". Ram, “The Genesis of Tel-Aviv.” For a balanced discussion see Kark, "), _c('em', [_vm._v("Jaffa")]), _vm._v(", 100–134; Shavit and Biger, "), _c('em', [_vm._v("The History of Tel-Aviv")]), _vm._v(", 17–24; Katz, "), _c('em', [_vm._v("Private Entrepreneurship")]), _vm._v(", 152–162.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "ch3en29"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en29"
    }
  }, [_vm._v("29")]), _vm._v(". Ehud Ben-Ezer, “The Beginning of Tel-Aviv in Literature,” in Naor, "), _c('em', [_vm._v("Idan")]), _vm._v(", 122–142.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en30"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en30"
    }
  }, [_vm._v("30")]), _vm._v(". Ya’ary-Poleskin, "), _c('em', [_vm._v("Dreamers and Warriors")]), _vm._v(", 17, 93, 250–253; "), _c('em', [_vm._v("M. Dizengoff: His Life and Deeds")]), _vm._v(" (Tel-Aviv, 1926), 175 [Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en31"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en31"
    }
  }, [_vm._v("31")]), _vm._v(". Yehoshua Kaniel, "), _c('em', [_vm._v("In Transition: The Jews of Eretz-Israel in the Nineteenth Century Between Old and New and Between Settlement of the Holy Land and Zionism")]), _vm._v(" (Jerusalem, 2000), 289–318, especially 298; Govrin, “Jerusalem and Tel-Aviv.”")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en32"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en32"
    }
  }, [_vm._v("32")]), _vm._v(". Ya’ary-Poleskin, "), _c('em', [_vm._v("M. Dizengoff")]), _vm._v(", 137.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en33"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en33"
    }
  }, [_vm._v("33")]), _vm._v(". "), _c('em', [_vm._v("YITA")]), _vm._v(" 1 (Tel-Aviv, 1921), 11.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en34"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en34"
    }
  }, [_vm._v("34")]), _vm._v(". Compare Johnston, "), _c('em', [_vm._v("Celebrations")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en35"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en35"
    }
  }, [_vm._v("35")]), _vm._v(". In his speech on the twenty-fifth anniversary, Weiss emphasized that Ahuzat Bayit was still active and never ceased to exist. “Speech of one of the founders,” "), _c('em', [_vm._v("YITA")]), _vm._v(", 6–7 (1934): 300.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en36"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en36"
    }
  }, [_vm._v("36")]), _vm._v(". Ya’ary-Poleskin, "), _c('em', [_vm._v("Dizengoff")]), _vm._v(", 140.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en37"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en37"
    }
  }, [_vm._v("37")]), _vm._v(". “Tel-Aviv’s Constitution,” "), _c('em', [_vm._v("YITA 2")]), _vm._v(" (5.8.1921): 6.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en38"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en38"
    }
  }, [_vm._v("38")]), _vm._v(". Shchori, "), _c('em', [_vm._v("A Dream that Became a City")]), _vm._v(", 399–400; Shavit and Biger, "), _c('em', [_vm._v("The History of Tel-Aviv")]), _vm._v(", 7, 93.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en39"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en39"
    }
  }, [_vm._v("39")]), _vm._v(". On urban Zionism as a different ideology, see S. Ilan Troen, "), _c('em', [_vm._v("Imagining Zion: Dreams, Designs, and Realities in a Century of Jewish Settlement")]), _vm._v(" (New Haven, 2003), 85–111.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en40"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en40"
    }
  }, [_vm._v("40")]), _vm._v(". Shavit and Biger, "), _c('em', [_vm._v("The History of Tel-Aviv")]), _vm._v(", 163.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en41"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en41"
    }
  }, [_vm._v("41")]), _vm._v(". Ludwig Lewisohn, “Letter from Abroad: A City unlike New-York,” "), _c('em', [_vm._v("Menorah Journal")]), _vm._v(" 9.2 (April 1925): 167–172. 1919 is not a print mistake.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en42"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en42"
    }
  }, [_vm._v("42")]), _vm._v(". Azaryahu, "), _c('em', [_vm._v("Tel-Aviv")]), _vm._v(", 45, confirms that the first anniversary was celebrated in 1929.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en43"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en43"
    }
  }, [_vm._v("43")]), _vm._v(". Druyanov, “Materials.”")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en44"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en44"
    }
  }, [_vm._v("44")]), _vm._v(". According to A. Z. Ben-Yishai’s retrospective. See Aricha, "), _c('em', [_vm._v("Tel-Aviv")]), _vm._v(", 153.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en45"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en45"
    }
  }, [_vm._v("45")]), _vm._v(". A. Reuveni, "), _c('em', [_vm._v("The Last Ships: A Novel")]), _vm._v(" (Warsaw, 1923), 111 [Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en46"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en46"
    }
  }, [_vm._v("46")]), _vm._v(". Based on my survey of all local news sections in "), _c('em', [_vm._v("Ha’aretz, Doar Hayom")]), _vm._v(", and "), _c('em', [_vm._v("Davar")]), _vm._v(" every March from 1920 to 1936. See Hizky Shoham, "), _c('em', [_vm._v("Mordechai is Riding the Horse: Purim Celebrations in Tel-Aviv (1908–1936) and the Building of the New Nation")]), _vm._v(" (Ramat-Gan, forthcoming) [Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en47"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en47"
    }
  }, [_vm._v("47")]), _vm._v(". Smilansky, "), _c('em', [_vm._v("A City is Born")]), _vm._v(", 102. Compare Feirberg, “The Land Lottery of Ahuzat Bayit,” 106.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en48"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en48"
    }
  }, [_vm._v("48")]), _vm._v(". Abraham Soskin, "), _c('em', [_vm._v("Tel-Aviv")]), _vm._v(" (Berlin, 1926) [Hebrew/German/English] (English source).")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en49"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en49"
    }
  }, [_vm._v("49")]), _vm._v(". Feirberg, “The Land Lottery of Ahuzat Bayit,” 93, n. 33.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en50"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en50"
    }
  }, [_vm._v("50")]), _vm._v(". Ya’ary-Poleskin, "), _c('em', [_vm._v("M. Dizengoff")]), _vm._v(", after p. 57.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en51"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en51"
    }
  }, [_vm._v("51")]), _vm._v(". Feirberg, “The Land Lottery of Ahuzat Bayit,” 93, n. 33.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en52"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en52"
    }
  }, [_vm._v("52")]), _vm._v(". M. G. [Moshe Glikson], “On the Agenda,” "), _c('em', [_vm._v("Ha’aretz")]), _vm._v(", 2.5.1929, 1; S. Hoffien, “The Jubilee Exhibition,” "), _c('em', [_vm._v("Doar Hayom")]), _vm._v(", 9 April 1929, 2.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en53"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en53"
    }
  }, [_vm._v("53")]), _vm._v(". The photo appears in "), _c('em', [_vm._v("YITA")]), _vm._v(" 5, 6–7 (1934): 305.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en54"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en54"
    }
  }, [_vm._v("54")]), _vm._v(". Aharon Vardi, ed., "), _c('em', [_vm._v("City of Miracles")]), _vm._v(" (Tel-Aviv, 1929), 6.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en55"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en55"
    }
  }, [_vm._v("55")]), _vm._v(". Ibid., 65.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en56"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en56"
    }
  }, [_vm._v("56")]), _vm._v(". “Tel-Aviv’s Twentieth Anniversary,” "), _c('em', [_vm._v("Ha’aretz")]), _vm._v(", 3 May 1929, 1 (emphasis original).")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _c('a', {
    attrs: {
      "id": "ch3en57"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en57"
    }
  }, [_vm._v("57")]), _vm._v(". Azaryahu, "), _c('em', [_vm._v("Tel-Aviv")]), _vm._v(", 42; Mann, "), _c('em', [_vm._v("A Place in History")]), _vm._v(", 13–16; Ilan Gur-Ze’ev, “Tel-Aviv and the Utopian Tradition,” "), _c('em', [_vm._v("Journal of Jewish Thought and Philosophy")]), _vm._v(" 2.2 (1993): 301–328.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en58"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en58"
    }
  }, [_vm._v("58")]), _vm._v(". M. Dizengoff, “Tel-Aviv’s day,” "), _c('em', [_vm._v("Ha’aretz")]), _vm._v(", 2 May 1929, 2. Glikson, “On the Agenda.”")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en59"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en59"
    }
  }, [_vm._v("59")]), _vm._v(". Dizengoff, ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en60"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en60"
    }
  }, [_vm._v("60")]), _vm._v(". “Tel-Aviv’s municipality declares Thursday, 22 of Nisan (2 May 1929) as Tel-Aviv day” (“Tel-Aviv’s anniversary” [public announcement by Tel-Aviv Municipality], "), _c('em', [_vm._v("Ha’aretz")]), _vm._v(", 30 April 1929, 1).")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en61"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en61"
    }
  }, [_vm._v("61")]), _vm._v(". Yossi Goldberg, “The Development of the Tourism Infrastructure in Mandatory Tel-Aviv (1917–1948)” (master’s thesis, Bar-Ilan University, 2005), 223–224 [Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en62"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en62"
    }
  }, [_vm._v("62")]), _vm._v(". “Mr. Dizengoff’s Speech,” "), _c('em', [_vm._v("Doar Hayom")]), _vm._v(", 9 April 1929, 1; “The opening of the exhibition and the Fair,” "), _c('em', [_vm._v("Ha’aretz")]), _vm._v(", 9 April 1929, 1.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en63"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en63"
    }
  }, [_vm._v("63")]), _vm._v(". “On The Agenda,” "), _c('em', [_vm._v("Ha’aretz")]), _vm._v(", 3 May 1929, 1.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en64"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en64"
    }
  }, [_vm._v("64")]), _vm._v(". Goldberg, “The Development of Tourism Infrastructure,” 129–152; Hizky Shoham, “ ‘A Huge National Assemblage’: Tel-Aviv as a Pilgrimage Site in Purim Celebrations (1920–1935),” "), _c('em', [_vm._v("Journal of Israeli History")]), _vm._v(" 28.1 (2009): 1–20.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en65"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en65"
    }
  }, [_vm._v("65")]), _vm._v(". “The Festival of Tel-Aviv,” "), _c('em', [_vm._v("Davar")]), _vm._v(", 2 May 1929; “Twenty Years to Tel-Aviv,” "), _c('em', [_vm._v("Davar")]), _vm._v(", 3 May 1929, 1.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en66"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en66"
    }
  }, [_vm._v("66")]), _vm._v(". Jabotinsky, “From My Kingdom’s Nights (to the Twentieth Anniversary of the Yishuv’s Capital)”; Ben-Avi, “The Day of Hebrew Independence,” "), _c('em', [_vm._v("Doar Hayom")]), _vm._v(", 2 May 1929.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en67"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en67"
    }
  }, [_vm._v("67")]), _vm._v(". Izmujik, “Moments (Memories of Tel-Aviv, to the Twentieth Year),” "), _c('em', [_vm._v("Ha’aretz")]), _vm._v(", 2 May 1929.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en68"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en68"
    }
  }, [_vm._v("68")]), _vm._v(". Compare Feirberg, “The Land Lottery of Ahuzat Bayit,” 88–91.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en69"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en69"
    }
  }, [_vm._v("69")]), _vm._v(". Yosef Eliyahu Chelouche, "), _c('em', [_vm._v("The Story of My Life, 1870–1930")]), _vm._v(" (Tel-Aviv, 2005 [1931]), 124 [Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en70"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en70"
    }
  }, [_vm._v("70")]), _vm._v(". Ibid., 121–139, especially p. 134.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en71"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en71"
    }
  }, [_vm._v("71")]), _vm._v(". Y. L. Wahlman, “A Party with the builders of Tel-Aviv,” in "), _c('em', [_vm._v("The Hebrew Capital: A Special Edition of Doar Hayom for Tel-Aviv’s Twenty-fifth Anniversary")]), _vm._v(" (June 1934), 57 [Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en72"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en72"
    }
  }, [_vm._v("72")]), _vm._v(". “The Half-Jubilee Celebrations,” "), _c('em', [_vm._v("YITA")]), _vm._v(" 5, 6–7 (1934): 295–308.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en73"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en73"
    }
  }, [_vm._v("73")]), _vm._v(". Avigdor Ha-Meiri, “Tel-Aviv—A City and Daughter in Israel [the meeting of Tel-Aviv committee twenty-five years ago],” "), _c('em', [_vm._v("The Hebrew Capital")]), _vm._v(", 58–59; Matmon-Cohen, Ben-Yaakov, Ben-Avi, and others, "), _c('em', [_vm._v("The Hebrew Capital")]), _vm._v(", 9–17, 36–39, 50–51, 57 [all in Hebrew].")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en74"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en74"
    }
  }, [_vm._v("74")]), _vm._v(". Azaryahu, "), _c('em', [_vm._v("Tel-Aviv")]), _vm._v(", 52–54.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en75"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en75"
    }
  }, [_vm._v("75")]), _vm._v(". “This is the Land,” Spielberg Archive VT DA330. Dizengoff’s full speech in "), _c('em', [_vm._v("YITA")]), _vm._v(" 5, 6–7 (1934), 307–308; on Dizengoff’s propaganda see Feirberg, “The Land Lottery of Ahuzat Bayit,” 94.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en76"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en76"
    }
  }, [_vm._v("76")]), _vm._v(". "), _c('em', [_vm._v("YITA")]), _vm._v(" 5, 6–7 (1934).")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en77"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en77"
    }
  }, [_vm._v("77")]), _vm._v(". Ibid., 295.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en78"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en78"
    }
  }, [_vm._v("78")]), _vm._v(". M. Dizengoff, “Toward Tel-Aviv’s Jubilee Exhibition,” "), _c('em', [_vm._v("YITA")]), _vm._v(" 4, 10 (July 1933), 334.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en79"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en79"
    }
  }, [_vm._v("79")]), _vm._v(". A. Z. Ben-Yishai, "), _c('em', [_vm._v("Tel-Aviv")]), _vm._v(" (Jerusalem, 1936), 1–2.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en80"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en80"
    }
  }, [_vm._v("80")]), _vm._v(". "), _c('em', [_vm._v("YITA")]), _vm._v(" 5, 6–7 (1934), 241, 300; Weiss, "), _c('em', [_vm._v("The Beginning of Tel-Aviv")]), _vm._v(", 32, 123–125.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('a', {
    attrs: {
      "id": "ch3en81"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en81"
    }
  }, [_vm._v("81")]), _vm._v(". K. Y. Silman, “The First Days,” in "), _c('em', [_vm._v("The Hebrew Capital")]), _vm._v(", 8.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en82"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en82"
    }
  }, [_vm._v("82")]), _vm._v(". Druyanov, "), _c('em', [_vm._v("Sefer Tel-Aviv")]), _vm._v(", 107–108; Feirberg, “The Land Lottery of Ahuzat Bayit,” 97.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en83"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en83"
    }
  }, [_vm._v("83")]), _vm._v(". Ze’ev Vilnai, "), _c('em', [_vm._v("Tel-Aviv Guide")]), _vm._v(" (Tel-Aviv, 1987 [1941]), 11, 13. See Feirberg, “The Land Lottery of Ahuzat Bayit,” n. 34.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en84"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en84"
    }
  }, [_vm._v("84")]), _vm._v(". Ibid., 105–107.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en85"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en85"
    }
  }, [_vm._v("85")]), _vm._v(". Unlike the simplistic analysis of Zali Gurevitch and Gideon Aran, “The Land of Israel: Myth and Phenomenon,” "), _c('em', [_vm._v("Studies in Contemporary Jewry")]), _vm._v(" 10 (1994): 195–210.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en86"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en86"
    }
  }, [_vm._v("86")]), _vm._v(". On the fragility of these spatial borders see Bernstein, "), _c('em', [_vm._v("Marginal Women;")]), _vm._v(" Razi, "), _c('em', [_vm._v("Forsaken Children")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en87"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en87"
    }
  }, [_vm._v("87")]), _vm._v(". Zerubavel, "), _c('em', [_vm._v("Time Maps")]), _vm._v(", 46–48.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en88"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en88"
    }
  }, [_vm._v("88")]), _vm._v(". See Hobsbawm and Ranger, “The Invention of Tradition,” 307; Norbert Elias, "), _c('em', [_vm._v("The Civilizing Process: The History of Manners")]), _vm._v(" (New York, 1978), 221–263.")]), _vm._v(" "), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "ch3en89"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#rch3en89"
    }
  }, [_vm._v("89")]), _vm._v(". See Rotbard, "), _c('em', [_vm._v("White City, Black City")]), _vm._v(", 78–88; Max Weber, "), _c('em', [_vm._v("The Methodology of the Social Sciences")]), _vm._v(" (New York, 1949), 113–163.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8461084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter03.vue
// module id = 93
// module chunks = 0